import React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      viewBox="0 0 512 512"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#283f71}"}</style>
      </defs>
      <title>{"icons"}</title>
      <path
        className="prefix__cls-1"
        d="M219.23 352.62l-32.07-24.14a4 4 0 014.81-6.39l27.26 20.52 27.25-20.52a4 4 0 114.82 6.39z"
      />
      <path
        className="prefix__cls-1"
        d="M219.22 492.78a4 4 0 01-2.71-1.06l-44.39-40.94 26.8-113.45a4 4 0 017.78 1.84L181 448.07l41 37.77a4 4 0 01-2.72 6.94z"
      />
      <path
        className="prefix__cls-1"
        d="M219.23 492.78a4 4 0 01-2.94-1.29 4 4 0 01.22-5.65l41-37.77-25.72-108.9a4 4 0 017.79-1.84l26.79 113.45-44.39 40.94a4 4 0 01-2.75 1.06zM368.6 347.66a4 4 0 01-3.19-1.59 63.48 63.48 0 00-10.16-10.62c-7.12-5.85-14.18-9.58-21-11.08l-.26-.06-58.48-17a16.91 16.91 0 01-4.69-2.2 16.73 16.73 0 01-7.27-11.94l-3-25.38 1.78-1.38c15.64-12.14 27.32-30.53 32.89-51.76l.71-2.73 2.8-.25c8.31-.73 14.82-10.92 14.82-23.2 0-11.39-5.51-21.05-13.1-23a4 4 0 011.95-7.76c11.27 2.83 19.15 15.46 19.15 30.71s-8.11 28-19.28 30.71c-6 21.07-17.74 39.43-33.25 52.13l2.44 20.94a8.73 8.73 0 003.79 6.23 9 9 0 002.45 1.15l58.36 16.94c8 1.79 16.15 6.05 24.22 12.69a70.93 70.93 0 0111.45 12 4 4 0 01-3.19 6.41zM52 402.51a4.32 4.32 0 01-.79-.08 4 4 0 01-3.14-4.71l5.49-27.46a71.35 71.35 0 0124.52-41c8-6.64 16.26-10.93 24.42-12.75l58.15-16.88a8.86 8.86 0 002.45-1.15 8.75 8.75 0 003.79-6.23l2.42-20.94c-15.5-12.71-27.21-31.07-33.27-52.14-11.14-2.74-19.22-15.35-19.22-30.7 0-14.86 7.61-27.42 18.51-30.53a4 4 0 112.2 7.69c-3.42 1-6.57 3.65-8.86 7.52a30.54 30.54 0 00-3.85 15.32c0 12.46 6.35 22.43 14.77 23.21l2.78.25.72 2.71c5.6 21.23 17.28 39.62 32.9 51.77l1.78 1.38-2.93 25.38a16.76 16.76 0 01-12 14.14l-58.53 17c-7 1.53-14.07 5.28-21.17 11.14a63.28 63.28 0 00-21.77 36.37L56 399.29a4 4 0 01-4 3.22z"
      />
      <path
        className="prefix__cls-1"
        d="M136.47 165.81a4 4 0 01-4-3.82c-.08-2-1.83-48.32 26.42-77.86 14.83-15.51 35.11-23.37 60.33-23.37s45.49 7.86 60.26 23.38c28.07 29.51 26.1 75.77 26 77.72a4 4 0 11-8-.39c0-.45 1.86-44.87-23.84-71.85-13.19-13.84-31.51-20.86-54.43-20.86s-41.26 7-54.52 20.87c-25.88 27-24.25 71.56-24.23 72a4 4 0 01-3.82 4.17z"
      />
      <path
        className="prefix__cls-1"
        d="M258 132.72a113.15 113.15 0 01-12.64-.73c-15.3-1.68-27.56-7.64-40.54-14-3.28-1.6-6.67-3.25-10.09-4.81-13.26-6.06-24.51-7.48-33.43-4.24-6.66 2.43-12.29 7.26-15.06 12.94a4 4 0 01-7.19-3.51c3.71-7.61 10.82-13.78 19.52-16.94 11-4 24.24-2.48 39.48 4.47 3.51 1.6 6.95 3.27 10.27 4.89 12.34 6 24 11.67 37.92 13.2 18.11 2 33.16-.44 47.35-7.67a4 4 0 113.63 7.12 83.81 83.81 0 01-39.22 9.28zM219.23 335.39l-50.37-45.1a4 4 0 115.34-6l45 40.32 45-40.32a4 4 0 015.33 6zM486.22 503.57h-156A11.2 11.2 0 01319 492.38v-74.8a4 4 0 118 0v74.8a3.19 3.19 0 003.19 3.19h156a3.19 3.19 0 003.19-3.19v-74.8a4 4 0 018 0v74.8a11.2 11.2 0 01-11.16 11.19z"
      />
      <path
        className="prefix__cls-1"
        d="M418.78 428.39a4 4 0 01-.08-8 526.26 526.26 0 0076.42-7.15V372a3.19 3.19 0 00-3.19-3.19H324.5a3.19 3.19 0 00-3.19 3.19v41.28a524.86 524.86 0 0076.42 7.15 4 4 0 01-.16 8 533.25 533.25 0 01-78.26-7.43 7.2 7.2 0 01-6-7.12V372a11.2 11.2 0 0111.19-11.19h167.43A11.2 11.2 0 01503.12 372v41.9a7.2 7.2 0 01-6 7.12 533.25 533.25 0 01-78.26 7.37z"
      />
      <path
        className="prefix__cls-1"
        d="M416.52 439.08h-16.6a6.28 6.28 0 01-6.27-6.27v-16.62a6.27 6.27 0 016.27-6.27h16.6a6.27 6.27 0 016.26 6.27v16.62a6.28 6.28 0 01-6.26 6.27zm-14.87-8h13.13v-13.16h-13.13zm14.87-13.16zM447.84 368.77a4 4 0 01-4-4v-15a4.43 4.43 0 00-4.42-4.43H377a4.43 4.43 0 00-4.42 4.43v15a4 4 0 01-8 0v-15A12.44 12.44 0 01377 337.38h62.41a12.44 12.44 0 0112.42 12.43v15a4 4 0 01-3.99 3.96z"
      />
      <path
        className="prefix__cls-1"
        d="M256 510.69A254.91 254.91 0 0175.75 75.52a254.92 254.92 0 01435.17 180.25 252.54 252.54 0 01-25.17 110.58 4 4 0 11-7.21-3.47A247 247 0 00256 8.86 246.91 246.91 0 0081.4 430.37 247.39 247.39 0 00322 493.79a4 4 0 112.13 7.71 255.48 255.48 0 01-68.13 9.19z"
      />
    </svg>
  )
}

export default SvgComponent
